'use client'

import {
    type RequestValidationTriggers,
    useValidationOnFields,
    type UseValidationOnFieldsOptions,
} from '../../../../../MyStichtingOpenHelpers/src/static'
import React, { FC, type ReactNode, useRef } from 'react'

interface Props {
    on: RequestValidationTriggers
    options?: UseValidationOnFieldsOptions
    children: ReactNode
}
/**
 * @description
 * This field can be  used to control how validation is handled
 *
 * IMPORTANT! this component does not need to be used when using the Form component {@link ../Form.tsx}.
 * One reason you may want to use this component, is when you want inputA to validate
 * on every keystroke, but inputB only on blur.
 *
 * Dispatches the events that will  be modified by event modifiers
 *
 * ## about event modifiers (not a web api)
 * In this project, an event modifier captures bubbling CustomEvents of a certain type and modifies it's detail property
 * For more info about the mechanics, read about event bubbling and propagation
 * {@link https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Event_bubbling}
 *
 * @param children -- children that are passed through will be styles as if this component is just a react Fragment
 * @param on -- controls validation frequency
 * @param options.noSilentValidation -- no need to use this, but may benefit performance on extremely large forms
 * */
export const ValidateFields: FC<Props> = ({ children, on, options }) => {
    const container = useRef<HTMLDivElement>(null)
    useValidationOnFields(container, on, options)

    return (
        <div className="contents" ref={container}>
            {children}
        </div>
    )
}
